import React from 'react';
import { useMutation } from '../hooks/useMutation';

const CONFIRM_PAYMENT_INFO = `
mutation($paymentId: String!, $meta: JSON) {
  confirmPaymentInfo(paymentId: $paymentId, meta: $meta)
}
`;

const ConfirmPayment = (props) => {
  const { mutate } = useMutation(CONFIRM_PAYMENT_INFO);

  const handleDwellingUpgrade = async () => {
    const query = props.query;
    if (query?.payment_intent && query?.redirect_status === 'succeeded') {
      const variables = { paymentId: query.payment_intent, meta: query };
      const result = await mutate(variables);

      if (result.data.confirmPaymentInfo) {
        window.location.reload();
      }
    }
  };

  React.useEffect(() => {
    if (props.query) {
      handleDwellingUpgrade();
    }
  }, []);

  return null;
};

export default ConfirmPayment;
